/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import CKEditor from 'react-ckeditor-component';
import { classnames as cx, propsUtils } from '@ba-ui-toolkit/utils';
import PropTypes from 'prop-types';

import styles from './RichTextEditor.scss';

const richtexteditorClassName = styles.richtexteditorClassName.replace(/"/g, '');
const { sanitize } = propsUtils;

export default class Editor extends Component {
	static propTypes = {
		content: PropTypes.any,
		config: PropTypes.object,
		isScriptLoaded: PropTypes.bool,
		scriptUrl: PropTypes.string,
		activeClass: PropTypes.string,
		events: PropTypes.object,
		className: PropTypes.string,
		style: PropTypes.object,
		validationErrorText: PropTypes.string,
		hasValidationError: PropTypes.bool,
	};

	static defaultProps = {
		className: '',
		style: {},
	};

	render() {
		const {
			className,
			style,
			content,
			config,
			isScriptLoaded,
			scriptUrl,
			events,
			validationErrorText,
			hasValidationError,
			...others
		} = this.props;

		const classNames = cx(richtexteditorClassName, {
			error: hasValidationError,
		});

		return (
			<div
				{...sanitize(others, Editor)}
				className={`${classNames} ${className}`}
				style={style}
			>
				<CKEditor
					content={content}
					config={config}
					isScriptLoaded={isScriptLoaded}
					scriptUrl={scriptUrl}
					events={events}
					activeClass={`${richtexteditorClassName}__CKEditor ${this.props.activeClass}`}
				/>
				<span className="validation-error">{validationErrorText || '\xa0'}</span>
			</div>
		);
	}
}
